import { Component, Inject, inject } from '@angular/core';
import { MatSnackBarRef, MAT_SNACK_BAR_DATA } from '@angular/material/snack-bar';

@Component({
  selector: 'app-bulgari-snackbar',
  templateUrl: './bulgari-snackbar.component.html',
  styleUrls: ['./bulgari-snackbar.component.scss']
})
export class BulgariSnackbarComponent {

  titleMessage: string = '';
  isError: boolean = false;

  constructor(@Inject(MAT_SNACK_BAR_DATA) public data: any) {
    this.titleMessage = data.message;
    this.isError = data.isError;
  }

  snackBarRef = inject(MatSnackBarRef);
}
